import { types } from "../types/types";
const intitalState = {
    allInvoice: [],
};

const invoiceReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.INVOICE:
            return {
                ...state,
                allInvoice: action.payload,
            };
        default:
            return { ...state };
    }
};

export default invoiceReducer;
